<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
  >
    <path
      d="M6.16671 1L1.5 5.5L6.16671 10.75"
      class="svg-path-1"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.5 5.5H16.8295C21.4182 5.5 25.3149 9.715 25.4935 14.875C25.6829 20.3275 21.6782 25 16.8295 25H5.4987"
      class="svg-path-2"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
